import React, { useMemo, useState } from 'react'
import { Button, Modal, Spinner } from 'react-bootstrap'
import { FaMagnifyingGlass } from 'react-icons/fa6'
import ModalTarifPnbp from './ModalTarifPnbp'
import { formatRupiah } from '../../../utilities/Utils'
import NonlalinService from '../../../services/nonlalin/NonlalinService'
import SweetAlert from 'react-bootstrap-sweetalert'

const ModalTargetUji = ({ showAddTargetUji, handleCloseTargetUji, datakomoditi }) => {

    const nonLalinService = useMemo(() => new NonlalinService(), [])
    const [tarifPnbp, setTarifPnbp] = useState(null)
    const [valueVolume, setValueVolume] = useState(0)
    const [valueTotalTarif, setValueTotalTarif] = useState(0)

    const [showPnbpTarif, setShowPnbpTarif] = useState(false)
    const handleClosePnbpTarif = () => setShowPnbpTarif(false)

    const handleClickPnbpTarif = () => {
        setShowPnbpTarif(true)
    }

    const handleClickPilih = (dataclick) => {
        // console.log(dataclick)
        setTarifPnbp(dataclick)
        setShowPnbpTarif(false)
    }

    const onChangeVolume = e => {
        setValueVolume(e.target.value)
        setValueTotalTarif(e.target.value * tarifPnbp.tarif)
    }

    const [loadingSave, setLoadingSave] = useState(false)
    const [showConfirmSave, setShowConfirmSave] = useState(false)
    const handleCloseConfirmSave = () => setShowConfirmSave(false)
    const handleShowConfirmSave = () => setShowConfirmSave(true)

    const [showSaveSuccess, setShowSaveSucces] = useState(false)
    const [showSaveFailed, setShowSaveFailed] = useState(false)

    const handleClickSimpan = async () => {
        setLoadingSave(true)
        try {
            const resNextSeriTarif = await nonLalinService.nextSeriTarif(datakomoditi.trNonlalinDtlPK.nomorAju,datakomoditi.trNonlalinDtlPK.seri )
            let jsonData = {
                trNonlalinDtlPeriksaPK : {
                    nomorAju: datakomoditi.trNonlalinDtlPK.nomorAju,
                    seri: datakomoditi.trNonlalinDtlPK.seri,
                    seriTarif: resNextSeriTarif.data
                },
                kdTarif: tarifPnbp.kdTarif,
                nmTarif: tarifPnbp.nmTarif,
                tarif: tarifPnbp.tarif,
                satuan: tarifPnbp.satuan,
                pembagi: tarifPnbp.pembagi,
                volume: valueVolume,
                totalTarif: valueTotalTarif,
                isUptCanCheck: 'Y'
            }
            const response = await nonLalinService.saveNonlalinDtlPeriksa(jsonData)
            if(response.data.kode === '200'){
                setShowConfirmSave(false)
                setShowSaveSucces(true)
            } else {
                setShowConfirmSave(false)
                setShowSaveFailed(true)
            }
        } catch (error) {
            setShowConfirmSave(false)
            setShowSaveFailed(true)
        }
        setLoadingSave(false)
    }

    const handleClickSaveSuccess = () => {
        setTarifPnbp(null)
        setValueTotalTarif(0)
        setValueVolume(0)
        setLoadingSave(false)
        setShowSaveSucces(false)
        handleCloseTargetUji()
    }

    const handleClickSaveFailed = () => {
        setLoadingSave(false)
        setShowSaveFailed(false)
    }

    const handleClickBatal = () => {
        setTarifPnbp(null)
        setValueTotalTarif(0)
        setValueVolume(0)
        handleCloseTargetUji()
    }

    return (
        <>
            <Modal
                show={showAddTargetUji}
                onHide={handleCloseTargetUji}
                backdrop='static'
                keyboard={false}
                size='lg'
                centered
            >
                <Modal.Header>
                    <h6>Target Pengujian</h6>
                </Modal.Header>
                <Modal.Body>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Nomor Aju</label>
                        <div className="col-sm-8">
                            <input type="text" className="col-sm-12 form-control-sm" name="nomor_aju" defaultValue={datakomoditi ? datakomoditi.trNonlalinDtlPK.nomorAju : ''} disabled />
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Nama Tarif</label>
                        <div className="col-sm-6">
                            <input type="text" className="col-sm-12 form-control-sm" name="jnsperiksa" value={tarifPnbp !== null ? tarifPnbp.nmTarif : ''} disabled />
                        </div>
                        <div className="col-sm-4">
                            <Button variant="primary" size="sm" onClick={() => handleClickPnbpTarif()} ><FaMagnifyingGlass /> Pilih Jenis</Button>{' '}
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Tarif Pnbp</label>
                        <div className="col-sm-6">
                            <input type="text" className="col-sm-12 form-control-sm" name="jnsperiksa" value={tarifPnbp !== null ? formatRupiah(tarifPnbp.tarif) : null} disabled />
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Satuan</label>
                        <div className="col-sm-6">
                            <input type="text" className="col-sm-12 form-control-sm" name="jnsperiksa" value={tarifPnbp !== null ? tarifPnbp.satuan : ''} disabled />
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Volume</label>
                        <div className="col-sm-6">
                            <input type="text" className="col-sm-12 form-control-sm" name="jnsperiksa" value={valueVolume} onChange={onChangeVolume} />
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Total Tarif</label>
                        <div className="col-sm-6">
                            <input type="text" className="col-sm-12 form-control-sm" name="totalTarif" value={formatRupiah(valueTotalTarif)} disabled />
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" size="sm" onClick={() => handleShowConfirmSave()}>Simpan</Button>{' '}
                    <Button variant="danger" size="sm" onClick={() => handleClickBatal()}>
                        Batal
                    </Button>
                </Modal.Footer>
            </Modal>
            <ModalTarifPnbp showAddPnbp={showPnbpTarif} handleClosePnbp={handleClosePnbpTarif} handleClickPilih={handleClickPilih} />
            {
                showConfirmSave &&
                <SweetAlert
                    title="Simpan Data Target Uji?"
                    warning
                    showCancel
                    confirmBtnText={
                        loadingSave ? (
                            <>
                                <Spinner animation="border" size="sm" className="me-2" />
                                Proses Simpan...
                            </>
                        ) : (
                            "Simpan"
                        )
                    }
                    confirmBtnBsStyle="primary"
                    cancelBtnText="Batal"
                    cancelBtnBsStyle="secondary"
                    onConfirm={handleClickSimpan}
                    onCancel={handleCloseConfirmSave}
                    focusCancelBtn
                    btnSize="sm"
                    disabled={loadingSave}
                >
                    {loadingSave && (
                        <div className="text-center">
                            <Spinner animation="border" variant="primary" />
                            <p className="mt-2">Proses Simpan data, harap tunggu...</p>
                        </div>
                    )}
                </SweetAlert>
            }
            {
                showSaveSuccess &&
                <SweetAlert
                    success
                    title="Simpan Data Target Uji Berhasil"
                    onConfirm={handleClickSaveSuccess}
                    btnSize="sm"
                />
            }
            {
                showSaveFailed &&
                <SweetAlert
                    danger
                    title="Simpan Data Target Uji Gagal"
                    onConfirm={handleClickSaveFailed}
                    btnSize="sm"
                    timeout={2000}
                />
            }
        </>
    )
}

export default ModalTargetUji